import auth from './auth';
import admin from './admin/routes';
import partner from './partner/routes';

export default [
    {
        path: '/',
        redirect: '/profile',
    },
    {
        path: '/403',
        name: 'forbidden',
        component: require('@/views/errors/403').default
    },
    ...auth,
    {
        path: '',
        component: require('@/layouts/default').default,
        meta: {
            auth: true
        },
        children: [
            ...admin,
            ...partner,

            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('@/views/dashboard/show'),
                meta: {
                    admin: false,
                }
            },

            /** Profile */
            {
                path: '/profile',
                name: 'profile.edit',
                component: require('@/views/profile/form').default,
            },
        ]
    },
];
